module.exports = __webpack_public_path__ + "media/components/assets/img/bg/sidebar-98e27a64bbd70bbe84374911e1a7f7d0.svg";